import React, { forwardRef } from 'react';
import { Icon } from '@chakra-ui/react';
import { QIconProps } from './Icon';

export const AIFetched = forwardRef<SVGSVGElement, Partial<QIconProps>>(
  (props, ref) => {
    return (
      <Icon viewBox="0 0 24 24" color="currentColor" {...props} ref={ref}>
        <svg>
          <g fill="currentColor">
            <path
              fillRule="evenodd"
              d="M6.884 12C9.015 13.218 10.782 14.985 12 17.116c1.218-2.131 2.985-3.898 5.116-5.116-2.131-1.218-3.898-2.985-5.116-5.116C10.782 9.015 9.015 10.782 6.884 12zm6.034-7.86c-.315-.853-1.521-.853-1.836 0-1.19 3.216-3.726 5.752-6.942 6.942-.853.315-.853 1.521 0 1.836 3.216 1.19 5.752 3.726 6.942 6.942.315.853 1.521.853 1.836 0 1.19-3.216 3.726-5.752 6.942-6.942.853-.315.853-1.521 0-1.836-3.216-1.19-5.752-3.726-6.942-6.942z"
              clipRule="evenodd"
            />
            <path d="M18.676 2.226c.111-.301.537-.301.648 0a4.15 4.15 0 0 0 2.45 2.45c.301.111.301.537 0 .648a4.15 4.15 0 0 0-2.45 2.45c-.111.301-.537.301-.648 0a4.15 4.15 0 0 0-2.45-2.45c-.301-.111-.301-.537 0-.648a4.15 4.15 0 0 0 2.45-2.45z" />
            <path d="M4.784 17.15c.074-.2.358-.2.432 0 .28.757.877 1.354 1.635 1.634.2.074.2.358 0 .432a2.77 2.77 0 0 0-1.635 1.634c-.074.2-.358.2-.432 0a2.77 2.77 0 0 0-1.634-1.634c-.2-.074-.2-.358 0-.432a2.77 2.77 0 0 0 1.634-1.634z" />
          </g>
        </svg>
      </Icon>
    );
  },
);

AIFetched.displayName = 'AIFetched';
